// 分销管理————分销订单管理
import http from "@/utils/request";
// 导出分销订单列表
export function httpOrderExport(data: any) {
  return http.post<Res.response<any>>({
    url: "/distribution/order/export/list",
    data,
    responseType: "blob",
  });
}
// 分销订单列表
export function httpOrderList(data: any) {
  return http.post<Res.response<any>>({
    url: "/distribution/order/list",
    data,
  });
}
